import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import run from "../images/run.jpg";
import Guide from "../images/guide.jpg";
import giveup from "../images/nevergivup.jpg";


function Multi() {

    const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

    return (
        <div>

            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <Carousel responsive={responsive}>
                            <div className="card border mb-3 me-3" >
                                <img className="card-img-top" src={run} alt="krishnagar_diagnostics"/>
                                <div className="card-body text">
                                   
                                </div>
                            </div>
                            <div className="card border mb-3 me-3" >
                                <img className="card-img-top" src={Guide} alt="krishnagar_diagnostics"/>
                                <div className="card-body text">
                                  
                                </div>
                            </div>
                            



                            <div className="card border mb-3 me-3" >
                                <img className="card-img-top" src={giveup} alt="quest diagnostics" />
                                <div className="card-body text">
                                   
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>

            </div>


        </div>
    )
}

export default Multi